import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";
import type { Solutions2Package } from "app/common/services/solutions2Helper";

import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import { DashboardGalleryPageV2 } from "app/pages/dashboard/DashboardGalleryPage-v2";
import { DashboardPageV2Container } from "app/pages/dashboard/DashboardPageV2Container";
import { DashboardParentPageV2 } from "app/pages/dashboard/DashboardParentPage-v2";
import { DashboardRootContainerV2 } from "app/pages/dashboard/DashboardRootContainer-v2";
import { DashboardEmptyPageV2 } from "app/pages/dashboard/DashboardEmptyPage-v2";
import {
    registerCampaignsDashboardWizard,
    registerRankTrackerDashboardWidgets,
} from "app/pages/digital-marketing/keywords-campaigns";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import { resolvers } from "single-spa/react-app/config/resolvers/resolvers";

// dm-keywords-campaigns owns its dashboard widgets and wizard step; the dashboard shell
// discovers them here, at boot, instead of app-shared importing into the module.
registerRankTrackerDashboardWidgets();
registerCampaignsDashboardWizard();

const configIdDeps = [
    "ShareDashboard",
    "IndustryAnalysis",
    "DesktopMobileWebTotal",
    "IndustryAnalysisGeneral",
    "KeywordAnalysis",
    "KeywordAnalysisOP",
];
export const DASHBOARD_PARENT_CONFIG_NAME = "dashboard";

export const dashboardConfig: RouterStateConfig = {
    track: {
        abstract: true,
        parent: "sw",
        component: DashboardRootContainerV2,
        resolve: [resolvers.dashboard],
    },
    dashboard: {
        parent: "track",
        configId: "Dashboard",
        url: "/dashboard",
        component: DashboardParentPageV2,
        configIdDeps,
        data: {
            menuKbItems: null as any,
            educationBarTag: "DASHBOARD",
        },
        pageId: {
            section: "dashboard",
        },
        trackingId: {
            section: "dashboard",
            subSection: "home",
        },
        clearSearch: true,
        resolve: [resolvers.customCategories],
        pageTitle: "dashboard.page.title",
        secondaryBarType: "Dashboards",
        secondaryBarType3: SecondarySideBarType3.Dashboards,
        packageName: "dashboards",
        isSecondaryBarOpen: true,
    },
    "dashboard-new": {
        parent: DASHBOARD_PARENT_CONFIG_NAME,
        url: "/new",
        component: () => <DashboardEmptyPageV2 />,
        configIdDeps,
        pageId: {
            section: "dashboard",
            subSection: "new",
        },
        trackingId: {
            section: "dashboard",
            subSection: "new",
        },
        clearSearch: true,
        pageTitle: "dashboard.page.title",
    },
    "dashboard-gallery": {
        parent: DASHBOARD_PARENT_CONFIG_NAME,
        url: "/gallery?projectId",
        component: DashboardGalleryPageV2,
        configIdDeps,
        pageId: {
            section: "dashboard",
            subSection: "gallery",
        },
        trackingId: {
            section: "dashboard",
            subSection: "gallery",
        },
        clearSearch: true,
        pageTitle: "dashboard.page.title",
        disableNewDashboardButton: true,
    },
    "dashboard-gallery-blank": {
        parent: "dashboard-gallery",
        url: "/blank",
        component: DashboardGalleryPageV2,
        configIdDeps,
        pageId: {
            section: "dashboard",
            subSection: "gallery",
            subSubSection: "blank",
        },
        trackingId: {
            section: "dashboard",
            subSection: "gallery",
            subSubSection: "blank",
        },
        clearSearch: true,
        pageTitle: "dashboard.page.title",
        disableNewDashboardButton: true,
    },
    "dashboard-exist": {
        parent: DASHBOARD_PARENT_CONFIG_NAME,
        url: "/:dashboardId",
        stateId: "dashboardId",
        component: DashboardPageV2Container,
        configIdDeps,
        pageId: {
            section: "dashboard",
            subSection: "exist",
        },
        trackingId: {
            section: "dashboard",
            subSection: "exist",
        },
        clearSearch: true,
    },
    "dashboard-created": {
        parent: DASHBOARD_PARENT_CONFIG_NAME,
        url: "/:dashboardId/new",
        stateId: "dashboardId",
        component: DashboardPageV2Container,
        configIdDeps,
        pageId: {
            section: "dashboard",
            subSection: "created",
        },
        trackingId: {
            section: "dashboard",
            subSection: "created",
        },
        clearSearch: true,
        pageTitle: "dashboard.page.title",
    },
};
